import { SelectFieldCombinedProps } from './types';

const usePresenter = (props: SelectFieldCombinedProps): SelectFieldCombinedProps => {
  return props;
};

export default usePresenter;
